import React from 'react';
import './docsHeroSection.scss';


const HeroSection = () => {
  return (
    <div className='docs-hero-section'>
      <div className='docs-hero-section__headline'>
        <div className='docs-hero-section__headline__pill'>Trafft’s Documentation</div>
        <div className='docs-hero-section__headline__title'>
          A comprehensive guide to all features
        </div>
        <div className='docs-hero-section__headline__subtitle'>
          Find the resources you need to enhance your Trafft experience
        </div>
      </div>
    </div>
)
}

export default HeroSection